import { Box } from "@mui/material";

export default function ViewerPlaybookToc({
  chapters,
  sidebar,
  activeItem,
  scrollToObject,
  hideDrawer = () => {},
}) {
  if (chapters === undefined) {
    return null;
  }
  return (
    <Box>
      {chapters.map((chapter, chapterIndex) => (
        <Box key={chapterIndex}>
          <Box
            onClick={() => {
              hideDrawer();
              scrollToObject(chapterIndex, 0);
            }}
            sx={{ cursor: "pointer", fontWeight: 600, mb: 1.5 }}
          >
            {chapterIndex + 1}.{" " + chapter.title}
          </Box>
          <Box sx={{ mt: 1, mb: 2 }}>
            {chapter.objects.map((chapterChildItem, index) => {
              let active =
                sidebar &&
                activeItem.chapter === chapterIndex &&
                activeItem.object === index;
              return (
                <Box
                  key={index}
                  onClick={() => {
                    hideDrawer();
                    scrollToObject(chapterIndex, index);
                  }}
                  sx={{
                    marginLeft: 2.2,
                    cursor: "pointer",
                    color: active ? "primary.main" : "inherit",
                    fontWeight: active ? 700 : "inherit",
                  }}
                >
                  {chapterChildItem.type === "play" && (
                    <Box
                      sx={{
                        fontSize: 14,
                        my: 0.5,
                      }}
                    >
                      {chapterChildItem?.data?.title === ""
                        ? "Untitled Play"
                        : chapterChildItem?.data?.title}
                    </Box>
                  )}
                  {chapterChildItem.type === "text" && (
                    <Box
                      sx={{
                        fontSize: 14,
                        my: 1,
                      }}
                    >
                      {chapterChildItem?.title}
                    </Box>
                  )}
                </Box>
              );
            })}
          </Box>
        </Box>
      ))}
    </Box>
  );
}
